import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVehicleDetails } from '../../services/VehiclesService';
import { VehicleDetails } from '../../types/Vehicles';
import { FeaturesManagement } from '../../../featuresControl';

function useGetVehicleById(id: string, fleetId: string, enabled: boolean = true, refetch: boolean = true): UseQueryResult<VehicleDetails> {
  return useQuery(
    ['vehicle', id, fleetId],
    async (): Promise<VehicleDetails> => getVehicleDetails(id, fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: refetch ? FeaturesManagement.productivity.refetchInterval : false,
      enabled: !!id && enabled,
    },
  );
}

export default useGetVehicleById;
